// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"246ebd36","138":"a7ae5593","439":"db6aaf5f","557":"cfd998e8"}[chunkId] + ".chunk.js";
};